import type { Link } from '@wix/public-schemas'
import type { ExternalLinkData } from './linksDataTypes'
import { addRelToLinkProps } from './linkUtils'

export const handleExternalLink = (linkData: ExternalLinkData): Link => {
	const { target, url, rel } = linkData
	const baseLinkProps = {
		href: url,
		target,
	}

	return addRelToLinkProps(baseLinkProps, rel)
}
